export enum JobStatus {
  QUEUED = 'queued',
  PROCESSING = 'processing',
  FINISHED = 'finished',
  FAILED = 'failed'
}

export enum JobInsightsStatus {
  NOT_STARTED = 'not_started',
  PROCESSING = 'processing',
  FINISHED = 'finished',
  FAILED = 'failed'
}

export enum JobMetricsStatus {
  NOT_STARTED = 'not_started',
  PROCESSING = 'processing',
  FINISHED = 'finished',
  FAILED = 'failed'
}
